import React from 'react';

const PageFold = () => (
    <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.917.34H15L.5 14.84V2.757A2.417 2.417 0 0 1 2.917.34Z" fill="#fff"/></svg>
);

export default PageFold;